<template>
  <div class="ondato-result">
    <h1>Verification in progress</h1>

    <div class="ondato-result-text">
      <p>We are verifying your identity. This may take a few minutes.</p>
      <p>You can track the status in "Verification" section of your account.</p>
    </div>

    <!-- <Button 
      :title="'settings'" 
      @btnClick="goToSettings" 
    /> -->
  </div>
</template>

<script>
import Button from '@/components/Button.vue'

export default {
  name: 'OnDatoResult',
  components: {
    Button
  },
  methods: {
    goToSettings() {
      this.$router.push({ name: 'Settings' })
    }
  }
}
</script>

<style scoped>
.ondato-result {
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  margin-top: 100px;
}

.ondato-result h1 {
}

.ondato-result-text {
    padding: 20px 0 20px 0;
}
</style> 